import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from '../core/services/v2/user.service';


@Component({
  selector: ' login',
  templateUrl: './login.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class LoginComponent {
  isLoggedIn: boolean = false;
  name: string;
  loginContextText = '';

  constructor(private userService: UserService, private router: Router) {
    this.userService.getUserDetails().subscribe(
      (result) => {
        this.isLoggedIn = true;
        this.name = result.name;
      },
      (error) => {
        console.error(error);
        this.isLoggedIn = false;
      }
    );

    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationEnd) {
          switch (event.url) {
            // case '/home':
            // case '/coming-soon':
            //   this.loginContextText = 'PATIENT';
            //   break;
            case '/physicians-claim':
              this.loginContextText = 'PHYSICIAN';
              break;
            case '/medical-retailers-claim':
              this.loginContextText = 'MEDICAL RETAILER';
              break;
            case '/medical-services-claim':
              this.loginContextText = 'MEDICAL SERVICE';
              break;
            case '/health-systems-claim':
              this.loginContextText = 'HEALTH SYSTEM';
              break;
            default:
              this.loginContextText = '';
          }
        }
      },
      (error) => { console.error(error); }
    );
  }
}
